import React from 'react';
import { useParams } from 'react-router-dom';

export default function useConversationId() {
  const { conversationId } = useParams();

  return Number(conversationId)!;
}
